// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import ContentBlockHorizontal from '/react4xp/components/ContentBlockHorizontal'

interface ListContentBlocksProps {
    contentBlock?: Array<{
        img?: {
            src: string
            alt: string
        }
        title?: string
        text?: string
    }>
}

export default function ListContentBlocks({
    contentBlock
}: ListContentBlocksProps) {
    return (
        <Section
            textColor='text-dark'
            className='list-content-blocks'
        >
            <div className='grid-container'>
                <div className='list-content-blocks__blocks'>
                    {contentBlock && contentBlock.length >= 1 ? (
                        contentBlock.map((item, i) => (
                            <ContentBlockHorizontal
                                key={i}
                                img={item.img}
                                title={item.title}
                                text={item.text}
                            />
                        ))
                    ) : null }
                </div>
            </div>
        </Section>
    )
}

